import axios from 'axios';

// Helper to determine if we're running on localhost
const isLocalhost = typeof window !== 'undefined' && window?.location?.hostname === 'localhost';

// Helper to get the base URL
const getBaseUrl = () => {
  if (process?.env?.NODE_ENV === 'development' || isLocalhost) {
    return 'http://localhost:3000';
  }
  return 'https://endure.health';
};

const axiosInstance = axios.create({
  baseURL: getBaseUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

export default axiosInstance;
